// Copyright © 2022 Move Closer
import VueSanitize from 'vue-sanitize';
// sanitize config options
const sanitizeOptions = {
    allowedTags: [
        'a',
        'br',
        'span'
    ],
    allowedAttributes: {
        a: ['href', 'target', 'style'],
        br: ['style'],
        span: ['style']
    }
};
export const registerSanitize = (Vue) => {
    Vue.use(VueSanitize, sanitizeOptions);
};
